export const EditLineItemHeader = "Edit item";
export const ChangeGlobalAttributeGroup = "Change Global Attribute Group";
export const EditProductLineLabel = "Product Line";
export const EditLineNumberPlaceholder = "Line";
